import React from 'react';
import PropTypes from 'prop-types';
import AccountDataPointPanel from './AccountDataPointPanel';
import { currencyFormatter } from '../../../../shared/functions';

export default function Sales({
  data, loading, dateView, title, subtitle, dayField, barColor, account, dateFieldName,
}) {
  return (
    <AccountDataPointPanel
      data={data}
      title={title}
      subtitle={subtitle}
      dayField={dayField}
      formatFunction={value => currencyFormatter({ value, account })}
      barColor={barColor}
      loading={loading}
      dateView={dateView}
      dateFieldName={dateFieldName}
    />
  );
}

Sales.defaultProps = {
  data: null,
  title: 'PPC Sales',
  subtitle: 'Total for Date Range',
  dayField: 'sales',
  barColor: '#f47b50',
  dateFieldName: 'rankDate',
};

Sales.propTypes = {
  loading: PropTypes.bool.isRequired,
  dateView: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Array),
  account: PropTypes.instanceOf(Object).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dayField: PropTypes.string,
  barColor: PropTypes.string,
  dateFieldName: PropTypes.string,
};
